export const SUBJECT_LIST = 'SUBJECT_LIST';


// WEBPACK FOOTER //
// ./src/redux/type/Subject.type.js